import { AbstractGlobalProvider } from './provider.js';
class Extra extends AbstractGlobalProvider {
    name = 'uber-extra-provider';
    celebrate() {
        for (const p of this.providers)
            p.celebrate();
    }
}
export const extra = new Extra();
